import React, { useState, useEffect, Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";
import "./index.scss";
import { useTranslation } from "react-i18next";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import Host from "../../Components/Host";
import HelmetComponent from "../../Components/HelmetComponent";
import { useGetUserDataQuery } from "../../services/login";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
function PaymentPolicy() {
  const { userId, userToken, userEmail, userName, isMember, isPaymentMethod, languageCode, countryCode } = useSelector(
    (state) => state.auth
  );
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const [getSearchId, setSearchId] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  const { data: userData } = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  const myElementRef = React.useRef(null);
  const myElementRefs = React.useRef(null);
  const myContact = React.useRef(null);

  const myPayment = React.useRef(null);
  const myBilling = React.useRef(null);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      if (hash === "returns") {
        myElementRef.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "shipping") {
        myElementRefs.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "contact") {
        myContact.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "billing") {
        myBilling.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "payment") {
        myPayment.current.scrollIntoView({ behavior: "smooth" });
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [window, window.location.hash]);

  return (
    <>
      <HelmetComponent title={"Payment Policy"} />
      <div className="statisc-page">
        <div className="container static-container">
          <div className="row static-row">
            <div className="col-md-10">
              <div
                className="static-container-card"
                style={{
                  textAlign: "left",
                  padding: "20px",
                  background: "#fcfcfc",
                  border: "1px solid #eee",
                  borderRadius: "7px",
                }}
              >
                <h3 style={{ padding: "20px 0px 20px 0px", fontWeight: 300, fontSize: "1.4rem" }}>
                  {t("Payment & Security Policy")}
                </h3>

                <p>
                  At luxuracart.com, we take the security of your personal information and payment details very
                  seriously. This Payment & Security Policy explains the payment methods we accept, how your payments
                  are processed, and the measures we put in place to protect your data every step of the way.
                </p>

                <h4>1. Accepted Payment Methods</h4>
                <p>We currently accept the following payment methods on our website:</p>
                <p>
                  • Credit cards – Visa, Mastercard, American Express
                  <br />
                  • Debit cards – Visa and Mastercard
                  <br />• UPI payment methods – BHIM UPI, Google Pay, Paytm, PhonePe
                </p>
                <p>All payments must be made in the currency and terms displayed at checkout.</p>

                <h4>2. How Payments Are Processed</h4>
                <p>
                  • All payments made on our website are processed securely using industry-standard encryption
                  technologies.
                  <br />
                  • We do not store your full credit or debit card details on our servers.
                  <br />• When you enter your card details at checkout, the information is transmitted securely to our
                  trusted payment processor for authorization and processing.
                </p>
                <p>This setup ensures that your sensitive payment data is handled as safely as possible.</p>

                <h4>3. Security Measures</h4>
                <p>
                  To protect your personal information and payment data, we use a combination of technical and
                  organisational safeguards, including:
                </p>
                <p>
                  • Secure servers to store customer information and related data.
                  <br />
                  • SSL (Secure Socket Layer) encryption to protect data transmitted between your browser and our
                  website.
                  <br />
                  • Restricted access controls and authentication measures (including multi-factor or two-factor
                  protection where applicable).
                  <br />• Regular reviews and updates of our security policies, systems, and procedures to ensure
                  effectiveness and alignment with best practices.
                </p>
                <p>
                  While no method of transmission over the internet or electronic storage is completely risk-free, we
                  are committed to doing everything reasonably possible to safeguard your data.
                </p>

                <h4>4. Changes to This Payment & Security Policy</h4>
                <p>
                  We may update this Payment & Security Policy from time to time. Any changes will be posted on this
                  page with an updated “last updated” date. Continued use of our website after changes are posted
                  constitutes acceptance of the updated policy.
                </p>
                <p>We encourage you to review this page periodically to stay informed.</p>

                <h4>5. Contact Us</h4>
                <p>
                  If you have any questions, concerns, or requests regarding this Payment & Security Policy, you can
                  contact us via:
                </p>
                <div style={{ lineHeight: 2 }}>
                 <p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: Host?.address,
                        }}
                      ></div>
                      <MailOutlineIcon style={{ fontSize: "1.1rem", color: "#444" }} />
                      &nbsp; {Host?.email} <br />
                    </p>
                </div>
                <p>• Live Chat: Available on luxuracart.com during support hours</p>
                <p>We are here to ensure your shopping experience remains safe, secure, and seamless.</p>

                <p>&nbsp;</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PaymentPolicy;
